import React from 'react';
import { openElvaChat } from '../bridge/elvaChatBridge';

function SparkleIcon() {
  return (
    <svg
      width={15}
      height={15}
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth={2}
      strokeLinecap="round"
      strokeLinejoin="round"
      aria-hidden
    >
      <path d="M12 3v3M12 18v3M3 12h3M18 12h3M5.5 5.5l2 2M16.5 16.5l2 2M5.5 18.5l2-2M16.5 7.5l2-2" />
    </svg>
  );
}

export function AiAssistantButton() {
  return (
    <button
      type="button"
      onClick={() => {
        openElvaChat();
      }}
      className="inline-flex h-8 cursor-pointer items-center justify-center gap-2 whitespace-nowrap rounded-[var(--r-md)] border border-[var(--brand-indigo)] bg-[var(--brand-indigo)] px-[15px] py-2 text-[13px] font-semibold text-[var(--text-on-accent)] shadow-[var(--shadow-nav-active)] transition duration-[var(--dur-fast)] disabled:cursor-not-allowed disabled:opacity-40"
    >
      <SparkleIcon />
      AI Assistant
    </button>
  );
}
